// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"5945056e","27":"15f0c8d3","80":"01fa92c0","83":"5da4141a","358":"ac636c80","496":"58d20dcf","748":"1a74c943","763":"72ba0b35","835":"6bdce65b","926":"93055396"}[chunkId] + ".chunk.js";
};